import React, {memo, useState} from "react";
import {Icon, Input, Paper} from "@material-ui/core";
import ScrollArea from "react-scrollbar";


const Step1 = ({services, setStep, setSelectServiceId}) => {
    const [servicesForView, setServicesForView] = useState(services);
    const [searchText, setSearchText] = useState('');

    const handleSearch = ({target}) => {
        const text = target.value;

        setSearchText(text);

        if(text.length > 2) {
            setServicesForView(services.filter(service => service.name.toLowerCase().search(text.trim().toLowerCase()) !== -1));
        } else {
            setServicesForView(services);
        }
    };

    return (
        <div className="registration-for-service__step-1 step-1">
            <div className="step-1__head">
                <Paper className="step-1__search">
                    <Icon className="step-1__search-icon">search</Icon>
                    <Input
                        placeholder="Поиск"
                        className="step-1__search-input"
                        disableUnderline
                        fullWidth
                        value={searchText}
                        onChange={handleSearch}
                    />
                </Paper>
            </div>
            {servicesForView.length ?
                <div className="step-1__content">
                    <ScrollArea
                        className="step-1__wrap-scroll"
                        contentClassName="step-1__scroll"
                        verticalScrollbarStyle={{borderRadius: 6, width: 6, backgroundColor: '#aaa'}}
                        verticalContainerStyle={{borderRadius: 8, width: 8}}
                        horizontal={false}
                        smoothScrolling={true}
                    >
                        {servicesForView.map(service =>
                            <div
                                className="step-1__item"
                                key={service.id}
                                onClick={() => {
                                    setSelectServiceId(service.id);
                                    setStep(2);
                                }}
                            >
                                <span className="step-1__item__name">{service.name}</span>
                                <span className="step-1__item__price">{service.price}</span>
                            </div>
                        )}
                    </ScrollArea>
                </div> :
                <p className="registration-for-service__error">Услуг не найдено</p>
            }
        </div>
    )
};

export default memo(Step1);